import { InnerBlocks } from '@wordpress/block-editor';

function Save({ attributes }) {
  const { backgroundColorClass= "" } = attributes;

  return (
    <div className={`fw-section ${backgroundColorClass}`} >
      <div className="row">
        <div className="col-12">

          <InnerBlocks.Content />


        </div>
      </div>
    </div>
  );
}

export default Save;
